/**
 * Componente: Confirmación de impresión física ("¿Se imprimió
 * correctamente?"). Mismo patrón visual que ConfirmarAccionPersonalModal
 * — no tiene botón de cerrar ni se descarta clickeando afuera, a
 * propósito: es una pregunta real que necesita una respuesta (Sí/No),
 * no algo para cancelar sin contestar.
 */

import React from 'react';

const ConfirmarImpresionModal = ({ nombreCompleto, procesando, onSi, onNo }) => (
  <div className="modal-overlay">
    <div className="modal-content confirmar-eliminar-modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <h2>¿Se imprimió correctamente?</h2>
      </div>

      <div className="modal-body">
        <p>Confirmá si la credencial de {nombreCompleto} salió bien de la impresora.</p>
      </div>

      <div className="modal-footer">
        <button type="button" className="btn-cancelar" onClick={onNo} disabled={procesando}>
          No
        </button>
        <button type="button" className="btn-guardar" onClick={onSi} disabled={procesando}>
          {procesando ? 'Confirmando...' : 'Sí'}
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmarImpresionModal;
